import { gql } from '@apollo/client';
import { resolvers as selectedFilters, typeDefs as selectedFiltersTypeDefs } from './selectedFilters';
import { resolvers as modals } from './modals';
import { resolvers as isEU } from './isEU';
import { resolvers as targetOffer } from './targetOffer';
import { resolvers as reel, typeDefs as reelTypeDefs } from './reel';
import { resolvers as shareMediaId } from './shareMediaId';
import { resolvers as userData, typeDefs as userDataTypeDefs } from './userData';
import { resolvers as notification, typeDefs as notificationTypeDefs } from './notification';
import { resolvers as deleteReelId } from './deleteReelId';
import { resolvers as searchSort } from './searchSort';

export const typeDefs = gql`
    ${selectedFiltersTypeDefs}
    ${reelTypeDefs}
    ${userDataTypeDefs}
    ${notificationTypeDefs}
`;

export const resolvers = {
    MediaPlayback: {
        ...reel.MediaPlayback,
    },
    Mutation: {
        ...selectedFilters.Mutation,
        ...modals.Mutation,
        ...isEU.Mutation,
        ...targetOffer.Mutation,
        ...reel.Mutation,
        ...shareMediaId.Mutation,
        ...notification.Mutation,
        ...deleteReelId.Mutation,
        ...searchSort.Mutation,
    },
    Query: {
        ...userData.Query,
        ...notification.Query,
    },
};
